import * as boardView from './board-view.tsx';
import * as collections from './collections.tsx';
import * as copyProjectConfiguration from './copy-project-configuration.tsx';
import * as deliveryItems from './delivery-items.tsx';
import * as fieldsSidebar from './fields-sidebar.tsx';
import * as formulaField from './formula-field.tsx';
import * as globalFieldsAdministration from './global-fields-administration.tsx';
import * as headerView from './header-view.tsx';
import * as ideaViewBentoSidebar from './idea-view-bento-sidebar.tsx';
import * as ideaView from './idea-view.tsx';
import * as issues from './issues.tsx';
import * as listView from './list-view.tsx';
import * as matrixView from './matrix-view.tsx';
import * as navBar from './nav-bar.tsx';
import * as noViewsScreen from './no-views-screen.tsx';
import * as playSidepanel from './play-sidepanel.tsx';
import * as project from './project.tsx';
import * as sharing from './sharing.tsx';
import * as timelineView from './timeline-view.tsx';
import * as viewPermissions from './view-permissions.tsx';
import * as view from './view.tsx';
import * as connections from './connections.tsx';
import * as issueTypes from './issue-types.tsx';

export const experience = {
	listView,
	formulaField,
	headerView,
	boardView,
	ideaView,
	ideaViewBentoSidebar,
	matrixView,
	navBar,
	project,
	timelineView,
	fieldsSidebar,
	issues,
	deliveryItems,
	sharing,
	globalFieldsAdministration,
	playSidepanel,
	noViewsScreen,
	view,
	viewPermissions,
	collections,
	copyProjectConfiguration,
	connections,
	issueTypes,
};
